export const puckCollectionSource = {
  beginDrag(props) {
    return {
      id: props.id,
      index: props.index,
    };
  },

  canDrag(props) {
    return props.canDrag;
  },
};

export const puckCollectionTarget = {
  hover(props, monitor) {
    const dragItem = monitor.getItem();
    const dragIndex = dragItem.index;
    const hoverIndex = props.index;

    if (dragItem.id === props.id || dragIndex === hoverIndex) {
      return;
    }

    props.moveCollection(dragIndex, hoverIndex);

    /* eslint-disable no-param-reassign */
    dragItem.index = hoverIndex;
    /* eslint-enable */
  },
};
